import {PREVIEW_ENTRY_CONTENT_ID} from '../../../../../utils/cms/previewEntry';

import type {IQueryBuilderConfig} from './IQueryBuilder';

// No aliased imports: also used by the SSR middleware (`server/middlewares/reactRenderer/urls.ts`).

/**
 * Default core configuration (`include` from `getMaxInclude`) contains ONLY mappings present in ALL brands.
 * Brand-specific mappings should be declared in brand configs.
 */
export const createCoreQueryBuilderConfig = (getMaxInclude: () => number): IQueryBuilderConfig => ({
	idMappings: {
		// An entry of any content type (`PreviewEntryPage`): no `content_type`
		[PREVIEW_ENTRY_CONTENT_ID]: {
			newId: '',
		},
		navigationItems: {
			newId: 'navigationItem',
		},
		contentCards: {
			newId: 'contentCard',
		},
		accordions: {
			newId: 'accordion',
			transformVariables: (variables) => {
				if (variables.ids) {
					variables.internalTitle = variables.ids;

					delete variables.ids;
				}
			},
		},
		badgeItems: {
			newId: 'badge',
			transformVariables: (variables) => {
				if (variables.ids) {
					variables.internalTitle = variables.ids;

					delete variables.ids;
				}
			},
		},
	},

	variableCaseHandlers: {
		ids: (variables, el) => {
			variables.sys = {
				id: variables[el],
			};
			delete variables[el];
		},
		slug: (variables, el) => {
			variables.fields.slug = variables[el];
			delete variables[el];
		},
		id: (variables, el) => {
			variables.fields.internalTitle = variables[el];
			delete variables[el];
		},
		allLocales: (variables, el) => {
			delete variables[el];
		},
	},

	parseObjectRules: {
		directKeys: ['locale', 'select'],
		useExistsForAllBooleans: false,
	},

	get defaultResultConfig() {
		return {
			include: getMaxInclude(),
		};
	},
});
